import { createSlice } from "@reduxjs/toolkit";
import { WALLET_BALANCE_LIST } from "constants/home";

import { REDUX_STATUS } from "constants/status";
import { ActivityResponse, ICardSettingForm } from "models/Home";
import { getUserPermission } from "store/user/actions";
import { getActivity, getWalletBalance, removeActivityById } from "./actions";
import { IHomeState } from "./types";

const initialState: IHomeState = {
  status: REDUX_STATUS.INITIAL,
  activityData: null,
  cardSettings: WALLET_BALANCE_LIST,
  pendingAmount: null,
  error: null
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    updateCardSetting: (state, { payload }: { payload: ICardSettingForm }) => {
      Object.keys(payload).forEach((key) => {
        state.cardSettings.forEach((item) => {
          if (item.value === key) item.show = payload[key];
        });
      });
    }
  },
  extraReducers: (builder) => {
    builder
      // Get Home Activity
      .addCase(getActivity.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getActivity.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.activityData = action.payload;
      })
      .addCase(getActivity.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Get Wallet Balance
      .addCase(getWalletBalance.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getWalletBalance.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.walletBalance = action.payload;
      })
      .addCase(getWalletBalance.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      .addCase(removeActivityById.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(removeActivityById.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        if (action.payload === 204) {
          state.activityData = {
            ...state.activityData,
            results: state.activityData?.results.filter((item) => item._id.$oid !== action.meta.arg)
          } as ActivityResponse;
        }
      })
      .addCase(removeActivityById.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      .addCase(getUserPermission.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getUserPermission.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        if (action.payload?.frontend_settings) {
          Object.keys(action.payload.frontend_settings).forEach((key) => {
            state.cardSettings.forEach((item) => {
              if (item.value === key)
                item.show =
                  action.payload.frontend_settings[
                    key as keyof typeof action.payload.frontend_settings
                  ];
            });
          });
        }
      })
      .addCase(getUserPermission.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      });
  }
});

export const { updateCardSetting } = homeSlice.actions;

export default homeSlice.reducer;
